import Cookies from 'js-cookie';

import { CustomerState } from '../../../api/lending/edge';
import { REFERRAL_CODE_STORAGE_KEY } from '../hooks/useReferralCode';

export async function postToHubspot(customerState: CustomerState) {
  // SELLER ONBOARDING FORM
  const HUBSPOT_FORM_URL =
    'https://api.hsforms.com/submissions/v3/integration/submit/6334445/0456b719-93db-4ac3-a393-2b968274c505';

  const utmParams = getUtmParams();

  const person = customerState?.application?.people?.[0];
  const company = customerState?.application?.company;
  const email = person?.emails && person.emails[0].email;
  const phoneNumber = person?.phones && person.phones[0].number;
  const residentialAddress =
    person?.residential_addresses && person.residential_addresses[0];

  const fields = [
    {
      name: 'title',
      value: person?.title || '',
    },
    {
      name: 'email',
      value: email,
    },
    {
      name: 'firstname',
      value: person?.first_name || '',
    },
    {
      name: 'lastname',
      value: person?.last_name || '',
    },
    {
      name: 'phone',
      value: '+44' + phoneNumber || '',
    },
    {
      name: 'company',
      value: company?.registered_company_name || '',
    },
    {
      name: 'company_number',
      value: company?.company_number || '',
    },
    {
      name: 'company_type',
      value: company?.type || '',
    },
    {
      name: 'address_line_1',
      value: `${residentialAddress?.house_number} ${residentialAddress?.street_line_1}`,
    },
    {
      name: 'address_line_2',
      value: residentialAddress?.street_line_2 || '',
    },
    {
      name: 'city',
      value: residentialAddress?.town || '',
    },
    {
      name: 'postcode',
      value: residentialAddress?.postcode || '',
    },
    {
      name: 'date_of_birth',
      value: person?.date_of_birth,
    },
    ...utmParams,
  ].filter((value) => value);

  const referralCode = getReferralCode();
  if (referralCode !== null) {
    fields.push({
      name: 'iwocapay_seller_referral_id',
      value: referralCode,
    });
  }

  const response = await fetch(HUBSPOT_FORM_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify({
      fields: fields,
      context: {
        hutk: Cookies.get('hubspotutk'),
      },
    }),
  });

  return response;
}

function getReferralCode(): string | null {
  return sessionStorage.getItem(REFERRAL_CODE_STORAGE_KEY);
}

type HubspotUtmParam = {
  name: string;
  value: string;
};

function getUtmParams() {
  const searchParams = new URLSearchParams(window.location.search);

  const validUtmParams = [
    'utm_campaign',
    'utm_source',
    'utm_term',
    'utm_content',
    'utm_medium',
  ];

  const utmParams: HubspotUtmParam[] = [];

  validUtmParams.forEach((param) => {
    const paramValue = searchParams.get(param);
    if (!paramValue) return;

    utmParams.push({
      name: param,
      value: paramValue,
    });
  });

  return utmParams;
}
